import styled from 'styled-components'
import { Text } from './Text'

export const LinkText = styled(Text)`
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`
